import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, makeStyles,} from "@material-ui/core";
import {LcmDialogProps} from "./DialogProps";
import {Controller, useForm} from "react-hook-form";
import {nameof} from "ts-simple-nameof";
import {fieldLabels} from "../../sections/fieldlabels";
import {Error} from "../../common/Error";
import {MarkdownEditor} from "@ofqual/portal-components/components/MarkdownEditor";
import {createFutureEvent} from "../../../redux/actions";
import {useDispatch} from "react-redux";
import {FutureEventModel} from "../../../domain/FutureEventModel";

import {DateTimePicker} from "@ofqual/portal-components/components/DateTimePicker";
import {TextField} from "@ofqual/portal-components/components/TextField";
import {useLookup} from "@ofqual/portal-core/core/hooks";
import {futureEventTypeLookupService} from "../../../services";
import {Select} from "@ofqual/portal-components/components/Select";

const defaultValues: Partial<FutureEventModel> = {
    dateTime: undefined,
    eventType: "",
    communicationType: undefined,
    note: "",
};

const useStyles = makeStyles(() => ({
    actions: {
        padding: 15,
    },
}));

export const FutureEventDialog: React.FC<LcmDialogProps> = ({
                                                                lcmItem,
                                                                onClose,
                                                            }) => {
    const {handleSubmit, control, errors} = useForm<FutureEventModel>({
        defaultValues,
    });

    const displayDateError = () => {
            if((errors.dateTime?.type === "required" || errors.dateTime?.type === "validate" )){
                return ( 
                    <Error data-test="future-event-date-time-validation">
                    This field is required
                </Error>)
            }
    }

    const classes = useStyles();
    const [futureEventTypeLookup] = useLookup(futureEventTypeLookupService);
    const dispatch = useDispatch();

    const onSubmit = (futureEventModel: FutureEventModel) => {
        // setExecuted(true)
        if (futureEventModel.dateTime && futureEventModel.eventType) {
            dispatch(createFutureEvent(lcmItem.id,
                new Date(futureEventModel.dateTime),
                futureEventModel.eventType,
                futureEventModel.communicationType,
                futureEventModel.note,
            ));
            onClose();
        }
    };
    const customValidation = (value : any) => {
        return new Date(value) > new Date();
    };

    return (
        <Dialog
            open={true}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            data-test="future-event-dialog"
        >
            <DialogTitle data-test="activity-title">Key date</DialogTitle>
            <Divider component="div"/>
            <DialogContent style={{minHeight: "250px"}}>
                <form>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>

                            <Controller
                                name={nameof<FutureEventModel>((x) => x.dateTime)}
                                control={control}
                                rules={{ validate: customValidation }}
                                as={
                                    <DateTimePicker
                                        minDate={new Date()} 
                                        label="Date and time"
                                        dataTest="future-event-date-time-field"
                                    />
                                }
                            />
                            {displayDateError()}
                        </Grid>

                        <Grid item xs={12}>
                            <Controller
                                control={control}
                                name={nameof<FutureEventModel>((x) => x.eventType)}
                                rules={{required: true}}
                                render={({onChange, value}) => (
                                    <TextField
                                        onChange={onChange}
                                        value={value}
                                        data-test="future-event-event-type-field"
                                        label="Event Type"
                                        required
                                    />
                                )}
                            />
                            {errors.eventType && (
                                <Error data-test="future-event-event-type-validation">
                                    This field is required
                                </Error>
                            )}
                        </Grid>

                        <Grid item xs={12}>
                            <Controller
                                control={control}
                                name={nameof<FutureEventModel>((x) => x.communicationType)}
                                as={
                                    <Select
                                        label={fieldLabels.meansOfCommunication}
                                        disabled={false}
                                        datatest="future-event-means-of-communication-field"
                                    >
                                        {futureEventTypeLookup}
                                    </Select>
                                }
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Controller
                                control={control}
                                name={nameof<FutureEventModel>((x) => x.note)}
                                rules={{required: false, maxLength: 5000}}
                                render={({onChange, value}) => (
                                    <>
                                        <label>{fieldLabels.note}</label>
                                        <MarkdownEditor
                                            onChange={onChange}
                                            value={value}
                                            dataTest="future-event-notes-text-field"
                                        />
                                    </>
                                )}
                            />
                            {errors.note?.type === "maxLength" && (
                                <Error data-test="summary-length-validation">
                                    Max length of 5000 characters exceeded
                                </Error>
                            )}
                        </Grid>
                    </Grid>
                </form>
            </DialogContent>
            <DialogActions className={classes.actions}>
                <Button
                    onClick={onClose}
                    color="primary"
                    data-test="future-event-close-button"
                >
                    Close
                </Button>
                <Button
                    onClick={handleSubmit(onSubmit)}
                    color="primary"
                    data-test="future-event-Add-button"
                >
                    Add
                </Button>
            </DialogActions>
        </Dialog>
    );
};
